import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/stores/pinia/useUserStore';
import BasicButton from '@/ui-components/BasicButton.vue';
import { AccountModal, SettingsModal } from '@/lazy-load-components';
import { faUserCog } from '@fortawesome/free-solid-svg-icons';
import Spinner from '@/ui-components/Spinner.vue';

import { ModalHelper } from '@/helpers/vfm/modal-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginMenuButtonNew',
  props: {
    dark: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { dark: boolean };



const userStore = useUserStore();
const { setLoginProgress } = userStore;
const { loginProgress, isLoggedIn } = storeToRefs(userStore);

const isLightTheme = computed(() => {
	return false;
	//return country.value === 'GB' && activeRoute.value.path === '/' && !isUserOnboarded.value;
});

const color = computed(() => {
	if (isLightTheme.value) {
		return 'ghost';
	}
	return props.dark ? 'dark' : 'primary';
});

function handleAccountClick() {
	ModalHelper.openModal(SettingsModal, {}, { id: 'settings' });
}

function handleLoginClick() {
	ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'login-modal' }, '', false, [], () => {
		setLoginProgress(true);
	});
}

return { __sfc: true,props, userStore, setLoginProgress, loginProgress, isLoggedIn, isLightTheme, color, handleAccountClick, handleLoginClick, BasicButton, faUserCog, Spinner }
}

})